import { CameraOutlined } from '@ant-design/icons'
import { Button } from '@crosscode/gravity-components'
import { NODE_ICONS } from './DeviceActions'
import type { InfraTableRow, PriceChecker } from './utils'
import { isCheckerProblematic, isInfraProblematic } from './utils'
import styles from '@/pages/HomePage.module.css'

interface InfraItem {
  id: string
  title: string
  ip?: string
  row: InfraTableRow
}

interface CheckerItem {
  id: string
  title: string
  ip?: string
}

interface Props {
  infra: InfraItem[]
  checkers: CheckerItem[]
  onSelectInfra: (id: string) => void
  onSelectChecker: (id: string) => void
  onShowAllProblems?: () => void
}

export function AttentionBlock({
  infra,
  checkers,
  onSelectInfra,
  onSelectChecker,
  onShowAllProblems,
}: Props) {
  const total = infra.length + checkers.length
  if (total === 0) return null

  return (
    <div className={styles.attention}>
      <div className={styles.attentionHead}>
        <span className={styles.attentionTitle}>Требует внимания</span>
        <span className={styles.attentionCount}>{total}</span>
        {onShowAllProblems ? (
          <Button size="small" onClick={onShowAllProblems}>
            Показать все
          </Button>
        ) : null}
      </div>
      <div className={styles.attentionList}>
        {infra.map((item) => (
          <button
            key={`infra-${item.id}`}
            type="button"
            className={styles.attentionItem}
            onClick={() => onSelectInfra(item.id)}
          >
            <span className={styles.attentionIcon}>{NODE_ICONS[item.row.nodeType]}</span>
            <span className={styles.attentionName}>{item.title}</span>
            <span className={styles.attentionIp}>{item.ip || '—'}</span>
            <span className={styles.attentionBadge}>
              {item.row.status === 'offline' ? 'Оффлайн' : 'Ошибка'}
            </span>
          </button>
        ))}
        {checkers.map((item) => (
          <button
            key={`pc-${item.id}`}
            type="button"
            className={styles.attentionItem}
            onClick={() => onSelectChecker(item.id)}
          >
            <span className={styles.attentionIcon}>
              <CameraOutlined />
            </span>
            <span className={styles.attentionName}>{item.title}</span>
            <span className={styles.attentionIp}>{item.ip || '—'}</span>
            <span className={styles.attentionBadge}>Проблема</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export function buildAttentionInfra(
  rows: InfraTableRow[],
  utmByNode: Record<string, Record<string, unknown>>,
  chzByNode: Record<string, Record<string, unknown>>,
): InfraItem[] {
  return rows
    .filter((row) => isInfraProblematic(row, utmByNode[row.nodeId], chzByNode[row.nodeId]))
    .map((row) => ({
      id: row.nodeId,
      title: row.title,
      ip: row.ip,
      row,
    }))
}

export function buildAttentionCheckers(
  checkers: PriceChecker[],
  checkerStatus: Record<string, string>,
): CheckerItem[] {
  return checkers
    .filter((c) => isCheckerProblematic(checkerStatus[String(c.id)], c))
    .map((c) => ({
      id: String(c.id),
      title: c.name || `Прайс-чекер ${c.id}`,
      ip: c.ip,
    }))
}
